import { cn } from "../../utils/classnames"

/**
 * Shared grid for lead table header + data rows so columns stay aligned.
 * md+: checkbox (1rem) | score (53px) | lead (1fr) | contact (11rem) | assigned (9rem) | action (9rem).
 */
export function leadScoreTableRowGridClass(includeCheckboxColumn: boolean) {
  return cn(
    "grid w-full grid-cols-1 gap-x-4 gap-y-4 pt-2",
    "md:items-start md:gap-y-0",
    includeCheckboxColumn
      ? "md:[grid-template-columns:1rem_53px_minmax(0,1fr)_11rem_9rem_9rem]"
      : "md:[grid-template-columns:53px_minmax(0,1fr)_11rem_9rem_9rem]"
  )
}
